<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { channelBarOption } from "./chart-options";

export default {
  name: "ChannelBarChart",
  components: { ChartCanvas },
  props: { rows: { type: Array, default: () => [] } },
  computed: {
    empty() {
      return !this.rows.length;
    },
    option() {
      return channelBarOption(this.rows);
    },
  },
};
</script>
